var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(250 376)",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -115.95,
    y: 0
  }, "EI KUVAA"), /*#__PURE__*/React.createElement("tspan", {
    x: -147.025,
    y: 61
  }, "SAATAVILLA")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.995 27.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.505,21h-225a18.75,18.75,0,0,0-18.75,18.75v187.5A18.75,18.75,0,0,0,37.505,246h225a18.75,18.75,0,0,0,18.75-18.75V39.75A18.75,18.75,0,0,0,262.505,21Zm-225-18.75A37.5,37.5,0,0,0,0,39.75v187.5a37.5,37.5,0,0,0,37.5,37.5h225a37.5,37.5,0,0,0,37.5-37.5V39.75a37.5,37.5,0,0,0-37.5-37.5H37.5Z",
    transform: "translate(0 0)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.118,19.609a9.377,9.377,0,0,1,10.817-1.741l70.827,36.5v84.361H2.255V101.238L51.873,57.111a9.376,9.376,0,0,1,11.809-1.166l49.876,33.236,69.568-69.555Z",
    transform: "translate(16.497 107.271)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.875,65.241A28.12,28.12,0,1,0,6.755,37.12a28.12,28.12,0,0,0,28.12,28.12Z",
    transform: "translate(49.502 49.502)",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.894a7ecc80def12d81f587c50d6875f5.svg";
export { ForwardRef as ReactComponent };